import DashboardService from '../../services/DashboardService'
import { HelperService } from '../../services/helper.service'
import { getDateOfISOWeek } from './../../utils/appUtils'
import * as type from './actionType'
import * as _ from 'lodash'
import { t } from 'i18next'
import {
  getActiveUserOrganisationReports,
  getWeeklyActiveUserOrganisationReports,
} from '@/services/OrganisationDashboardService'

type AppDispatchType = any

const service = new DashboardService()
const helperService = new HelperService()

export const getDashboardUserSessionReports = async ({
  filtersData,
  isOrganisation,
}: {
  filtersData: any
  isOrganisation?: boolean
}) => {
  try {
    const response = isOrganisation
      ? filtersData.type === 'weekly'
        ? await getWeeklyActiveUserOrganisationReports(filtersData)
        : await getActiveUserOrganisationReports(filtersData)
      : filtersData.type === 'weekly'
        ? await service.getDashboardWeeklyActiveUserSessionReports(filtersData)
        : await service.getDashboardActiveUserSessionReports(filtersData)

    return {
      activeUsersSessions:
        filtersData.type === 'weekly'
          ? response.data.data.report_data.rows.map((row: any) => {
              return {
                ...row,
                date: getDateOfISOWeek(row.week, new Date().getFullYear()),
              }
            })
          : response.data.data.report_data.rows,
      sessionsCount: response.data.data.report_data.rows
        .map((session: any) => session.session_count)
        .reduce(function (n: any, val: any) {
          return n + val
        }, 0),
      usersCount: response.data.data.report_data.rows
        .map((session: any) => session.user_count)
        .reduce(function (n: any, val: any) {
          return n + val
        }, 0),
      average_daily_session:
        response.data.data.report_data.summary?.average_daily_session,
      average_daily_user:
        response.data.data.report_data.summary?.average_daily_user,
    }
  } catch (error: any) {
    console.log('🚀 ~ getDashboardUserSessionReports ~ error:', error)
    return {
      activeUsersSessions: [],
      sessionsCount: 0,
      usersCount: 0,
      average_daily_session: 0,
      average_daily_user: 0,
    }
  }
}

export const getDashboardUniqueActiveUsersSummary =
  (filtersData: any) => async () => {
    try {
      let response =
        await service.getDashboardActiveUserSessionReports(filtersData)
      let getDashboardActiveUserSessionReports =
        await service.getDashboardUniqueActiveUsersSummary(filtersData)
      return Promise.resolve({
        activeUsersSessions:
          filtersData.type === 'weekly'
            ? response.data.data.report_data.rows.map((row: any) => {
                return {
                  ...row,
                  date: getDateOfISOWeek(row.week, new Date().getFullYear()),
                }
              })
            : response.data.data.report_data.rows,
        sessionsCount: response.data.data.report_data.rows
          .map((session: any) => session.session_count)
          .reduce(function (n: any, val: any) {
            return n + val
          }, 0),
        // sessionGrowth: ((response.data.data.report_data.rows[length-1] - response.data.data.report_data.rows[length-2]) / response.data.data.report_data.rows[length-2]) * 100,
        usersCount: getDashboardActiveUserSessionReports.data.data.report_data
          .rows
          ? getDashboardActiveUserSessionReports.data.data.report_data.rows[0]
              .unique_active_user
          : 0,
        average_daily_session:
          response.data.data.report_data.summary.average_daily_session,
        average_daily_user:
          response.data.data.report_data.summary.average_daily_user,
      })
    } catch (error: any) {
      return Promise.reject({
        activeUsersSessions: [],
        sessionsCount: 0,
        usersCount: 0,
        average_daily_session: 0,
        average_daily_user: 0,
      })
    }
  }

export const getDashboardTopQuestions = (filtersData: any) => async () => {
  try {
    const response = await service.getDashboardTopQuestions(10, filtersData)
    return Promise.resolve({
      top_questions: response.data.data.report_data.rows,
    })
  } catch (error: any) {
    return Promise.reject({
      top_questions: [],
    })
  }
}

export const getLatestComments =
  (filterData: any) => async (dispatch: AppDispatchType) => {
    try {
      const response = await service.getLatestComments(filterData)
      dispatch({
        type: type.FETCH_DASHBOARD_SESSION_COUNT,
        payload: {
          comments: response.data.data.report_data
            ? response.data.data.report_data.rows
            : [],
        },
      })
      return Promise.resolve({
        comments: response.data.data.report_data
          ? response.data.data.report_data.rows
          : [],
      })
    } catch (error: any) {
      dispatch({
        type: type.FETCH_DASHBOARD_SESSION_COUNT,
        payload: {
          comments: [],
          loading: false,
          error: true,
        },
      })
      return Promise.reject({
        comments: [],
      })
    }
  }

export const getQuizSubmissions = async (filtersData: any) => {
  try {
    let response: any
    let updatedResponse: any[]
    if (filtersData.frequency === 'weekly') {
      response = await service.getWeeklyQuizSubmissions(filtersData)
      updatedResponse = await response.data.data.report_data.rows.map(
        (reportData: any) => {
          return {
            submission_count: reportData.submission_count,
            date: reportData.week,
          }
        },
      )
    } else {
      response = await service.getQuizSubmissions(filtersData)
    }
    return Promise.resolve({
      data:
        filtersData.frequency === 'weekly'
          ? updatedResponse
          : response.data.data.report_data.rows,
      count: response.data.data.report_data.rows
        .map((session: any) => session.submission_count)
        .reduce(function (n: any, val: any) {
          return n + val
        }, 0),
    })
  } catch (error: any) {
    return Promise.reject({
      data: [],
      count: 0,
    })
  }
}

export const getRatingsSummary = (filtersData: any) => async () => {
  try {
    const response = await service.getRatingsSummary(filtersData)
    return Promise.resolve({
      ratingSummary: response.data.data.report_data
        ? response.data.data.report_data
        : [],
    })
  } catch (error: any) {
    return Promise.resolve({
      ratingSummary: {
        rows: [],
        summary: {
          rating_average: 0,
          rating_count: 0,
        },
      },
    })
  }
}

export const getConversationTurnSummary = (filtersData: any) => async () => {
  try {
    const conversationTurnSummary =
      await service.getConversationTurnSummary(filtersData)
    const conversationTurns = await service.getConversationTurns(filtersData)
    return Promise.resolve({
      conversationTurnSummary: conversationTurnSummary.data.data.report_data
        .rows
        ? conversationTurnSummary.data.data.report_data.rows
        : [],
      conversationTurns: conversationTurns.data.data.report_data.rows
        ? conversationTurns.data.data.report_data.rows
        : [],
    })
  } catch (error: any) {
    return Promise.reject([])
  }
}

export const getAllUsersDashboard = () => async () => {
  try {
    const users = await service.getAllUsers()
    return Promise.resolve(users.data.data.users)
  } catch (error: any) {
    return Promise.reject([])
  }
}

export const getAllGroupUsersDashboard = (filtersData: any) => async () => {
  try {
    const users = await service.getAllGroupUsers(filtersData)
    return Promise.resolve(users.data.data.report_data)
  } catch (error: any) {
    return Promise.reject([])
  }
}

export const getAllGroupUsersModalDashboard =
  (filtersData: any, _id: any, filter_is_attempted: any) => async () => {
    try {
      const users = await service.getAllGroupUsersModal(
        filtersData,
        _id,
        filter_is_attempted,
      )
      return Promise.resolve(users.data.data.report_data)
    } catch (error: any) {
      return Promise.reject([])
    }
  }

export const getTopUsers =
  (filtersData: any, page: number = null, page_size: number = null) =>
  async () => {
    try {
      const users = await service.getTopUsers(filtersData, page, page_size)
      return Promise.resolve(users.data.data.report_data)
    } catch (error: any) {
      return Promise.reject([])
    }
  }

export const getReportsDailyActiveSession = (filtersData: any) => async () => {
  try {
    const users = await service.getDailyActiveSessionReport(filtersData)
    return Promise.resolve(users.data.data.report_data)
  } catch (error: any) {
    return Promise.reject([])
  }
}

export const getAverageMonthlySessionsReports =
  (filtersData: any) => async () => {
    try {
      const response =
        await service.getDashboardAverageMonthlyActiveUsersSessionReports(
          filtersData,
        )
      return Promise.resolve({
        averageMonthlyUserSessionsLoading: false,
        averageMonthlyUserSessions: response.data.data.report_data.rows,
        sessionsCount: response.data.data.report_data.rows
          .map((session: any) => session.session_count)
          .reduce(function (n: any, val: any) {
            return n + val
          }, 0),
        // sessionGrowth: ((response.data.data.report_data.rows[length-1] - response.data.data.report_data.rows[length-2]) / response.data.data.report_data.rows[length-2]) * 100,
        usersCount: response.data.data.report_data.rows
          .map((session: any) => session.user_count)
          .reduce(function (n: any, val: any) {
            return n + val
          }, 0),
        average_monthly_user:
          response.data.data.report_data.summary.average_monthly_user,
        average_monthly_session:
          response.data.data.report_data.summary.average_monthly_session,
      })
    } catch (error: any) {
      // helperService.showToaster('Something went wrong while updating hiccups.');
      return Promise.reject({
        averageMonthlyUserSessionsLoading: false,
        averageMonthlyUserSessions: [],
        sessionsCount: 0,
        usersCount: 0,
        average_monthly_user: 0,
        average_monthly_session: 0,
      })
    }
  }

export const getDailyReturningUsers = (filtersData: any) => async () => {
  try {
    const response = await service.getDailyReturningUsers(filtersData)
    return Promise.resolve({
      dailyReturningUsersLoading: false,
      dailyReturningUsers: response.data.data.report_data.rows,
      returningUserCount: response.data.data.report_data.rows
        .map((session: any) => session.returning_user)
        .reduce(function (n: any, val: any) {
          return n + val
        }, 0),
      total_returning_users:
        response.data.data.report_data.summary.total_returning_users,
      average_returning_users:
        response.data.data.report_data.summary.average_returning_users,
    })
  } catch (error: any) {
    // helperService.showToaster('Something went wrong while updating hiccups.');
    return Promise.reject({
      dailyReturningUsersLoading: false,
      dailyReturningUsers: [],
      returningUserCount: 0,
      usersCount: 0,
      total_returning_users: 0,
      average_returning_users: 0,
    })
  }
}

export const getMonthlyReturningUsers = (filtersData: any) => async () => {
  try {
    const response = await service.getMonthlyReturningUsers(filtersData)
    return Promise.resolve({
      dailyReturningUsersLoading: false,
      dailyReturningUsers: response.data.data.report_data.rows,
      returningUserCount: response.data.data.report_data.rows
        .map((session: any) => session.returning_user)
        .reduce(function (n: any, val: any) {
          return n + val
        }, 0),
      total_returning_users:
        response.data.data.report_data.summary.total_returning_users,
      average_returning_users:
        response.data.data.report_data.summary.average_returning_users,
    })
  } catch (error: any) {
    // helperService.showToaster('Something went wrong while updating hiccups.');
    return Promise.reject({
      dailyReturningUsersLoading: false,
      dailyReturningUsers: [],
      returningUserCount: 0,
      usersCount: 0,
      total_returning_users: 0,
      average_returning_users: 0,
    })
  }
}

export const getClasses = () => async () => {
  try {
    const response = await service.getClasses()
    let classes = []
    classes = response.data.data.classes.map((classobj: any) => {
      return {
        ...classobj,
        label: classobj.name,
        labelForSorting: classobj.name.toLowerCase(),
        value: classobj._id,
        connectionIds: classobj.connections
          .map(
            (c: { channel_id: string; connection_id: string }) =>
              c.connection_id,
          )
          .join(','),
        studentGroupId: classobj.student_group_id,
        adminGroupId: classobj.admin_group_id,
      }
    })
    return Promise.resolve({
      classes: _.orderBy([...classes], ['labelForSorting'], ['asc']),
    })
  } catch (error: any) {
    return Promise.reject({
      classes: [],
    })
  }
}

export const getQuizDetailByQuizId = (quizId: any, filter: any) => async () => {
  try {
    const response = await service.getQuizDetailByQuizId(quizId, filter)
    return Promise.resolve({
      rows: response.data.data.report_data.rows,
      pagination: response.data.data.report_data.pagination,
    })
  } catch (error: any) {
    return Promise.reject({
      rows: [],
      pagination: null,
    })
  }
}

export const getQuizDetailByUser =
  (quizId: any, userId: any, userType: any) => async () => {
    try {
      const response = await service.getQuizDetailByUser(
        quizId,
        userId,
        userType,
      )
      return Promise.resolve({
        quiz_submissions: response.data.data.quiz_submissions,
      })
    } catch (error: any) {
      return Promise.reject({
        quiz_submissions: [],
      })
    }
  }

export const getQuizByQuizId = (quizId: any) => async () => {
  try {
    const quizDetailById = await service.getQuizDetailById(quizId)
    return Promise.resolve({
      quizDetail: quizDetailById.data.data.quiz,
    })
  } catch (error: any) {
    return Promise.resolve({
      quizDetail: null,
    })
  }
}

export const getRoleplayPerformanceReport = (params: any) => async () => {
  try {
    const quizDetailById = await service.getRoleplayPerformanceReport(params)
    return Promise.resolve({
      quizDetail: quizDetailById?.data?.data?.criteria,
    })
  } catch (error: any) {
    return Promise.resolve({
      quizDetail: null,
    })
  }
}

export const getQuizRoleplaySubmissions = async (quizId: any, filter: any) => {
  try {
    const response = await service.getQuizRoleplaySubmissions(quizId, filter)
    return Promise.resolve({
      rows: response?.data?.data?.roleplay_submissions,
      pagination: response?.data?.data?.pagination,
    })
  } catch (error: any) {
    return Promise.reject({
      rows: [],
      pagination: null,
    })
  }
}

export const getStudentsYetToAttempt = async (quizId: any, filter: any) => {
  try {
    const response = await service.getStudentsYetToAttempt(quizId, filter)
    return Promise.resolve({
      rows: response.data.data.report_data.rows,
      pagination: response.data.data.report_data.pagination,
    })
  } catch (error: any) {
    return Promise.reject({
      rows: [],
      pagination: null,
    })
  }
}

export const getQuizTotalNUmberOfSubmissionsCount =
  (quizId: any, filter: any) => async () => {
    try {
      const response = await service.getQuizTotalNUmberOfSubmissionsCount(
        quizId,
        filter,
      )
      return Promise.resolve(response.data.data.report_data?.rows)
    } catch (error: any) {
      return Promise.reject(0)
    }
  }

export const getQuizDetailFirstSubmissionSummary =
  (quizId: any, filter: any) => async () => {
    try {
      const response = await service.getQuizDetailFirstSubmissionSummary(
        quizId,
        filter,
      )
      return Promise.resolve(response.data.data.report_data?.rows)
    } catch (error: any) {
      return Promise.reject(0)
    }
  }

export const exportReportUsingDateAndType = async (
  report_name: string,
  file_format: string,
  filtersData?: any,
) => {
  try {
    const response = await service.exportReportUsingDateAndType(
      report_name,
      file_format,
      filtersData,
    )
    return Promise.resolve(response.data)
  } catch (error: any) {
    return Promise.reject(null)
  }
}

export const exportReportUsingDateAndTypeAsync = async (
  report_name: string,
  file_format: string,
  filtersData?: any,
) => {
  try {
    const response = await service.exportReportUsingDateAndTypeAsync(
      report_name,
      file_format,
      filtersData,
    )
    return Promise.resolve(response.data)
  } catch (error: any) {
    return Promise.reject(null)
  }
}

export const getLearnerSubmissions = (user_id: string) => async () => {
  try {
    const response = await service.getLearnerSubmissions(user_id)
    let preData: any = {}

    response.data.data.submissions.forEach((item: any) => {
      if (item.topic_name) {
        if (!(item.topic_name in preData)) {
          preData[item.topic_name] = {
            id: item.topic_name,
            data: [],
          }
        }

        // if (preData[item.topic_name].data.length < 15) {
        preData[item.topic_name] = {
          id: item.topic_name,
          data: preData[item.topic_name].data.concat([
            {
              x: item.take,
              y: item.score,
            },
          ]),
        }
        // }
      }
    })
    return Promise.resolve(Object.values(preData))
  } catch (error: any) {
    console.log('err', error)
    // helperService.showToaster('Something went wrong while updating hiccups.');
    return Promise.reject([])
  }
}

export const getUserFeedbacks = async (payload: any) => {
  try {
    const res = await service.getFeedbacks(payload)
    return Promise.resolve(res.data.data.report_data)
  } catch (error: any) {
    return Promise.reject([])
  }
}

export const downloadUserConversations = (payload: any) => async () => {
  try {
    const response = await service.downloadUserConversations(payload)
    return Promise.resolve(response.data)
  } catch (error: any) {
    return Promise.reject([])
  }
}

export const getSubmissionReviewCount =
  (quizId: string = null, filter: any = {}) =>
  async () => {
    try {
      const response = await service.getSubmissionReviewCount(quizId, filter)
      return Promise.resolve(response.data.data.submission_review_count)
    } catch (error: any) {
      return Promise.reject([])
    }
  }

export const sendReminders = async (quiz_id: string, data: string[]) => {
  try {
    await service.sendReminders(quiz_id, data)
    helperService.showToaster(t('Reminder successfully sent.'), 'success')
    return Promise.resolve(null)
  } catch (error: any) {
    helperService.showToaster(t('Something went wrong please try again later.'))
    return Promise.reject([])
  }
}

export const getQuestionCorrectnessReport =
  (quiz_id: string, filters: any) => async () => {
    try {
      const response = await service.getQuestionCorrectnessReport(
        quiz_id,
        filters,
      )
      return Promise.resolve(response.data.data.questions)
    } catch (error: any) {
      helperService.showToaster(
        t('Something went wrong please try again later.'),
      )
      return Promise.reject([])
    }
  }

export const getQuestionAnalyticsReport =
  (quiz_id: string, filters: any) => async () => {
    try {
      const response = await service.getQuestionAnalyticsReport(
        quiz_id,
        filters,
      )
      return Promise.resolve(response.data.data.questions)
    } catch (error: any) {
      helperService.showToaster(
        t('Something went wrong please try again later.'),
      )
      return Promise.reject([])
    }
  }
export const getQuestionAnalyticsSubmissionReport =
  (quiz_id: string, filters: any) => async () => {
    try {
      const response = await service.getQuestionAnalyticsSubmissionReport(
        quiz_id,
        filters,
      )
      return Promise.resolve(response.data.data)
    } catch (error: any) {
      return Promise.reject([])
    }
  }

export const getQuizSubmissionsList = async (filter: any) => {
  try {
    const response = await service.getReportQuizSubmissionsList(filter)
    return Promise.resolve(response.data.data.report_data)
  } catch (error: any) {
    return Promise.reject([])
  }
}

export const ExportDiscussions = (data: any) => async () => {
  try {
    const response = await service.ExportDiscussions(data)
    return Promise.resolve(response.data)
  } catch (error: any) {
    return Promise.reject(null)
  }
}
